import React, {
    useMemo,
} from 'react';
import { useQuery } from '@tanstack/react-query';

import * as UTILS from "../utils/utils";
import config from "../config/config";
import * as QUERIES from "../queries/query-functions";

import ViewAlternativeDates from "./view-alternative-dates";
import LoadingIndicator from '../components/loading-indicator';
import ViewInstanceDate from './view-instance-date';

export default function InstanceEventSummary(props) {
    const { 
            isPending,
            isFetching,
            data: imageData,
        } = useQuery({
            queryKey: ['imageData', config.EVENT.event_id],
            queryFn: () => QUERIES.getEventImage(config.EVENT.event_id),
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: 86400000
        });

    const formattedDate = useMemo(() => {
        return UTILS.formatDateTime(config.INSTANCE?.date);
    }, [config.INSTANCE?.date]);
    return (
        <header className="instance-event-summary instance-event-summary__header">
            <div className='instance-event-summary__image'>
            {isPending || isFetching ?
                    <LoadingIndicator />
                : imageData ?
                    <div dangerouslySetInnerHTML={{__html: imageData}}></div>
                : config.EVENT.event_image ?
                    <img src={config.EVENT.event_image } className='instance-event-summary__img' />
                : config.EVENT.event_venue && config.LOGO_URLS[config.EVENT.event.event_venue] ?
                    <img src={config.LOGO_URLS[config.EVENT.event_venue]} className={`instance-event-summary__img instance-event-summary__img--logo ${config.EVENT.event_venue}`} />
                : config.LOGO_URLS?.site ?
                    <img src={config.LOGO_URLS?.site} className='instance-event-summary__img instance-event-summary__img--logo' />
                : null
                }
            </div>
            <div className='instance-event-summary__image-holder'>
                {config.EVENT.name ?
                    <h1 className="instance-event-summary__title">{ config.EVENT.name }</h1>
                :null}
            {/* {formattedDate ?
                <p className="instance-event-summary__date">{ formattedDate }</p>
            :null}
            {config.EVENT?.attributes[config.OPTION_FIELDS.venue_attribute_name] ?
                <p className="instance-event-summary__venue">{ config.EVENT.attributes[config.OPTION_FIELDS.venue_attribute_name] }</p>
            :null} */}


                {props.showAlternativeDates &&
                    (props.isReserved === undefined || props.isReserved ?
                        <ViewAlternativeDates selectedInstanceDate={config.INSTANCE.date} date={formattedDate} venue={config.EVENT.event?.event_venue} />
                        : <ViewInstanceDate date={formattedDate} venue={config.EVENT.event?.event_venue} />
                    )
                }
            </div>
        </header>
    );
}